import { Group, Text, Button, Avatar, Box } from '@mantine/core';
import { Check } from 'react-feather';
import type { CohortCoachWithDetails } from '../../../services/api/cohortCoaches';
import { getAvatarColor, getInitialsFromParts } from '../../../utils/avatarHelpers';
import classes from './CoachSelectionBar.module.css';

interface CoachSelectionBarProps {
  coach: CohortCoachWithDetails;
  selectedCount: number;
  onCancel: () => void;
  onAssign: () => void;
}

export function CoachSelectionBar({
  coach,
  selectedCount,
  onCancel,
  onAssign,
}: CoachSelectionBarProps) {
  const fullName = `${coach.first_name || ''} ${coach.last_name || ''}`.trim() || coach.email;
  const avatarColor = getAvatarColor(coach.id);

  return (
    <Box className={classes.bar}>
      <Group justify="space-between" wrap="nowrap">
        {/* Left side - Coach chip and selection status */}
        <Group gap="lg" wrap="nowrap">
          {/* Coach chip with white background */}
          <Box className={classes.coachChip}>
            <Group gap="sm" wrap="nowrap">
              <Avatar
                size={36}
                radius="xl"
                src={coach.avatar_url}
                styles={{
                  root: { backgroundColor: avatarColor },
                  placeholder: { color: '#FFFFFF', backgroundColor: avatarColor },
                }}
              >
                {getInitialsFromParts(coach.first_name, coach.last_name)}
              </Avatar>
              <Text fw={600} size="sm" c="dark">{fullName}</Text>
            </Group>
          </Box>

          {/* Selection status text */}
          <Text size="sm" c="blue" fw={500}>
            Select groups to assign • {selectedCount} selected
          </Text>
        </Group>

        {/* Right side - Actions */}
        <Group gap="sm" wrap="nowrap">
          <Button
            variant="outline"
            color="blue"
            size="sm"
            onClick={onCancel}
            styles={{
              root: { backgroundColor: 'white' },
            }}
          >
            Cancel
          </Button>
          <Button
            size="sm"
            color="blue"
            leftSection={<Check size={16} />}
            onClick={onAssign}
            disabled={selectedCount === 0}
          >
            Assign to {selectedCount} group{selectedCount !== 1 ? 's' : ''}
          </Button>
        </Group>
      </Group>
    </Box>
  );
}

export default CoachSelectionBar;
